import React, { useState, useEffect, useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';
import { formatVND } from '../Utils/FormatPrice';
import { filterAndFormatData } from '../Utils/FormatDate';
import moment from 'moment';

// Static options
const staticOptions = {
  chart: {
    type: 'area',
    stacked: false,
    height: 350,
    zoom: { type: 'x', enabled: true, autoScaleYaxis: true },
    toolbar: { show: false },
  },
  colors: ['rgb(0, 154, 89)'],
  dataLabels: { enabled: false },
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      inverseColors: false,
      opacityFrom: 0.5,
      opacityTo: 0,
      stops: [0, 90, 100],
    },
  },
  yaxis: {
    min: 0,
    labels: { formatter: val => formatVND(val) },
    title: { text: 'Giá' },
  },
  tooltip: {
    shared: false,
    y: {
      formatter: val => `${formatVND(val)}`,
    },
  },
};

const ApexChartMarKetPrice = ({ chartData, marketPriceName, xLabels, xLabelReplace }) => {
  const title = useMemo(() => `GIÁ ${marketPriceName.title}`, [marketPriceName.title]);

  const options = useMemo(
    () => ({
      ...staticOptions,
      xaxis: {
        type: 'category',
        categories: xLabels,
        tickAmount: 5, // Điều chỉnh số lượng tick mà bạn muốn hiển thị
        labels: {
          rotate: -45, // Xoay nhãn để tránh chồng chéo
          rotateAlways: true, // Luôn xoay nhãn
          hideOverlappingLabels: false, // Hiển thị tất cả các nhãn, không ẩn nhãn bị chồng chéo
          style: {
            fontSize: '12px',
          },
        },
      },
      title: {
        text: title,
        align: 'center',
        style: { fontSize: '16px', fontWeight: 'bold', color: '#263238' },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { height: 200 },
            legend: { position: 'bottom' },
            yaxis: { labels: { show: false } },
          },
        },
      ],
    }),
    [title, xLabels],
  );

  const [series, setSeries] = useState([{ name: 'Giá', data: [] }]);
  useEffect(() => {
    const formattedData = filterAndFormatData(chartData);

    // Chuyển đổi tất cả các ngày trong formattedData sang định dạng 'DD-MM-YYYY' (để giống với xLabels)
    const priceMap = formattedData.reduce((acc, item) => {
      const formattedDate = moment(item.date).format('DD-MM-YYYY'); // Đảm bảo định dạng giống xLabels
      acc[formattedDate] = item.price;
      return acc;
    }, {});

    // Ánh xạ dữ liệu price vào xLabels, thêm null cho những ngày không có dữ liệu
    const alignedData = xLabels.map(date => priceMap[date] ?? null);

    // Cập nhật series dữ liệu
    setSeries([{ name: 'Giá', data: alignedData }]);
  }, [chartData, xLabels]);

  return (
    <div id="chart">
      <ReactApexChart options={options} series={series} type="area" height={350} />
    </div>
  );
};

export default ApexChartMarKetPrice;
